import { Box, Spinner, Text } from '@lego/klik-ui';
import { useMemo } from 'react';
import { useWorkspaceFile } from '@/hooks/workspace';

type Props = {
  workspaceId: number;
  fileId: number;
};

const StatusMessage = ({ message, isError = true }: { message: string; isError?: boolean }) => (
  <Box background="white" p={4}>
    <Text color={isError ? 'red.600' : undefined}>{message}</Text>
  </Box>
);

export const FileContent = ({ workspaceId, fileId }: Props) => {
  const { data, error, isLoading } = useWorkspaceFile(workspaceId, fileId);
  const workspaceFile = data?.data;

  const decodedContent = useMemo(() => {
    if (!workspaceFile?.fileContents) return null;
    try {
      return atob(workspaceFile.fileContents);
    } catch {
      return null;
    }
  }, [workspaceFile?.fileContents]);

  if (isLoading) {
    return (
      <Box background="white" p={4}>
        <Spinner margin={'auto'} size={'sm'} />
      </Box>
    );
  }

  if (error) return <StatusMessage message="Failed to load file" />;
  if (!workspaceFile) return <StatusMessage message="File not found" />;
  if (decodedContent === null) return <StatusMessage message="Failed to decode file content" />;
  if (decodedContent === '') return <StatusMessage message="File is empty" />;

  return (
    <Box background="white">
      <Text background="#f1f1f1" boxShadow="inner" p={4} whiteSpace="pre-wrap">
        {decodedContent}
      </Text>
    </Box>
  );
};
